export class ActionModel {

   id: number;
   last_action: number;
   name: string;
   player_id: number;
   value: string;
   action: string;

    
}